var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('div',{staticClass:"col-md-12 home-box"},[_c('Breadcrumbs',{attrs:{"title":'All Other Income Entries'}}),_c('AllIncomeEntries')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }